$.onmount('[data-component="shopify/order_viewer"]', function () {
  var $el = $(this)

  $el.on('oms:shopify-refund-complete', function () {
    window.location.reload()
  })
})
